
'use strict'

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./pages.cjs.production.min.js')
} else {
  module.exports = require('./pages.cjs.development.js')
}
